"use strict";
import React from "react";
import { EmailForwarder } from "./email_forwarder";
import FactorInvoicesService from "./factor_invoices_service";
import WaitingSpinner from "../components/waiting_spinner";
var EmailForwarderWrapper = React.createClass({
  getInitialState: function() {
    return {
      loading: true,
      email: null,
      error: null
    };
  },
  componentDidMount: function() {
    this.fetchData();
  },
  findEmail: function(emailMessages) {
    if (this.props.emailId) {
      return emailMessages.find((e) => e.id === this.props.emailId) || null;
    }
    return emailMessages[0] || null;
  },
  fetchData: function() {
    FactorInvoicesService.fetchWithID(this.props.factorInvoiceId).then(
      (data) => {
        const email = this.findEmail(data.factor_invoice.email_messages || []);
        if (!email) {
          this.setState({ loading: false, error: "No email found to forward" });
          return;
        }
        this.setState({ loading: false, email });
      },
      () => {
        this.setState({ loading: false, error: "Failed to load invoice data" });
      }
    );
  },
  render: function() {
    if (this.state.loading) {
      return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: true });
    }
    if (this.state.error) {
      return /* @__PURE__ */ React.createElement("div", { className: "email-forwarder__error" }, this.state.error);
    }
    return /* @__PURE__ */ React.createElement(
      EmailForwarder,
      {
        email: this.state.email,
        onCancel: this.props.onCancel,
        onDone: this.props.onDone
      }
    );
  }
});
export default EmailForwarderWrapper;
